import React from "react";

const TradeFilters = ({ filters, onFilterChange }) => {
  const handleFilterChange = (key, value) => {
    onFilterChange({
      ...filters,
      [key]: value,
    });
  };

  return (
    <div className="trade-filters">
      <div className="filters-grid">
        <div className="filter-group">
          <label>Date Range</label>
          <select
            value={filters.dateRange}
            onChange={(e) => handleFilterChange("dateRange", e.target.value)}
          >
            <option value="all">All Time</option>
            <option value="today">Today</option>
            <option value="week">This Week</option>
            <option value="month">This Month</option>
            <option value="year">This Year</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Symbol</label>
          <input
            type="text"
            value={filters.symbol}
            onChange={(e) => handleFilterChange("symbol", e.target.value)}
            placeholder="Enter symbol..."
          />
        </div>

        <div className="filter-group">
          <label>Direction</label>
          <select
            value={filters.direction}
            onChange={(e) => handleFilterChange("direction", e.target.value)}
          >
            <option value="all">All</option>
            <option value="LONG">Long</option>
            <option value="SHORT">Short</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Status</label>
          <select
            value={filters.status}
            onChange={(e) => handleFilterChange("status", e.target.value)}
          >
            <option value="all">All</option>
            <option value="WIN">Winners</option>
            <option value="LOSS">Losers</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default TradeFilters;
